import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f18c420"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table-outline rounded-3 overflow-hidden" }
const _hoisted_2 = { class: "session-list w-100 d-none d-md-table" }
const _hoisted_3 = { class: "session-list__header fw-bold" }
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = { class: "session-list__header__title" }
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = { class: "session-list__header__title" }
const _hoisted_8 = ["aria-label"]
const _hoisted_9 = { class: "session-list__header__title" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "session-list__header__title me-3" }, " Webinar Link ")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_12 = {
  key: 0,
  class: "session-list__loader"
}
const _hoisted_13 = {
  key: 1,
  class: "session-list__body"
}
const _hoisted_14 = {
  key: 2,
  class: "session-list__message"
}
const _hoisted_15 = { class: "d-block d-md-none" }
const _hoisted_16 = {
  key: 0,
  class: "session-list__loader"
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }

import { computed, ref } from 'vue'
import WebinarListItem from '@/components/WebinarListItem'
import WebinarMobileListItem from '../WebinarListItem/WebinarMobileListItem.vue'
import PaginationBar from '@/components/PaginationBar'
import { SessionListItemViewModel } from '../SessionListItem/SessionListItem.interfaces'
import TableLoader from '@/components/TableLoader'
import locales from './WebinarList.locales.en.json'
import ArrowUp from '@/icons/ArrowUp.vue'
import ArrowDown from '@/icons/ArrowDown.vue'
import ExpandArrows from '@/icons/ExpandArrows.vue'
import { WebinarSortCriteria } from '../SessionRegistryStore'
import { computePaginatedSessions, computeTotalSessionPages } from '@/utils/pagination'
import { checkIsEmpty } from '@/utils/is-empty'


export default /*#__PURE__*/_defineComponent({
  __name: 'WebinarList',
  props: {
    webinars: {},
    searchCriteria: {},
    isLoading: { type: Boolean },
    isReady: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ['filtered-webinar-list-length-updated'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit

const props = __props

const webinarsPerPage = computed(() => webinarsExpanded.value ? 100000 : 4)
const currentPage = ref(1)
const filteredWebinars = computed(computeFilteredWebinars)
const totalWebinarPages = computed(() => computeTotalSessionPages(filteredWebinars.value, webinarsPerPage.value))
const paginatedWebinars = computed(() => computePaginatedSessions(filteredWebinars.value, webinarsPerPage.value, currentPage.value))
const webinarsExpanded = ref(false)

const firstIndex = computed(() => !paginatedWebinars.value.length ? 0 : 1 + webinarsPerPage.value * (currentPage.value - 1)) 
const lastIndex = computed(() => !paginatedWebinars.value.length ? 0 : firstIndex.value + paginatedWebinars.value.length - 1)
const isSortDescending = ref(true)
const sortCriteria = ref(WebinarSortCriteria.Date)

const showMessage = computed(() => {
  return !paginatedWebinars.value.length && props.isReady && !props.isLoading
})

const messageValue = computed(() => {
  return props.searchCriteria
    ? locales.message_no_results_with_criteria
    : locales.message_no_results
})

function toggleSort(criteriaClicked: WebinarSortCriteria) {
	if (criteriaClicked == sortCriteria.value)
	{
		isSortDescending.value = !isSortDescending.value
	}
	else
	{
		isSortDescending.value = true
	}
	sortCriteria.value = criteriaClicked
}

function webinarExpand() {
  currentPage.value = 1 
  webinarsExpanded.value = !webinarsExpanded.value
}

function computeFilteredWebinars() {
  let filtered: SessionListItemViewModel[] = Array.from(props.webinars)

  if (!checkIsEmpty(props.searchCriteria)) {
    const upperCaseCriteria = props.searchCriteria.toUpperCase()
    
    filtered = filtered.filter((webinar) => {
      const upperCaseDate = webinar.localStartDateTime.toLocaleString('en-us', {month: 'long', day: 'numeric', year: 'numeric'}).toUpperCase()
      const upperCaseStartEndTime = webinar.localStartEndTime.toUpperCase()
      const upperCaseDescription = webinar.event.description.toUpperCase()
      return (
        upperCaseDate.includes(upperCaseCriteria) ||
        upperCaseStartEndTime.includes(upperCaseCriteria) ||
        upperCaseDescription.includes(upperCaseCriteria)
      )
    })
  }

  if (sortCriteria.value == WebinarSortCriteria.Title) {
    filtered.sort((leftElement, rightElement) => leftElement.event.description.localeCompare(rightElement.event.description) )
  }
  if (sortCriteria.value == WebinarSortCriteria.Date) {
    filtered.sort((leftElement, rightElement) => (leftElement.localStartDateTime.getTime() - rightElement.localStartDateTime.getTime()))
  }
  if (sortCriteria.value == WebinarSortCriteria.Time) {
    filtered.sort((leftElement, rightElement) => ((leftElement.localStartDateTime.getHours() - rightElement.localStartDateTime.getHours()) * 60
      + (leftElement.localStartDateTime.getMinutes() - rightElement.localStartDateTime.getMinutes())))
  }
  if (!isSortDescending.value) {
    filtered.reverse()
  }

  currentPage.value = 1

  emit('filtered-webinar-list-length-updated', filtered.length)

  return filtered
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", _hoisted_3, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", null, [
            _createElementVNode("button", {
              class: "session-list__header__sort-button ms-3",
              type: "button",
              "aria-label": 'sort by title ' + (sortCriteria.value === _unref(WebinarSortCriteria).Title && isSortDescending.value ? 'ascending' : 'descending'),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleSort(_unref(WebinarSortCriteria).Title)))
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createTextVNode(" Title "),
                (sortCriteria.value !== _unref(WebinarSortCriteria).Title)
                  ? (_openBlock(), _createBlock(ExpandArrows, {
                      key: 0,
                      class: "arrow-slot",
                      "aria-hidden": "true"
                    }))
                  : (isSortDescending.value)
                    ? (_openBlock(), _createBlock(ArrowDown, {
                        key: 1,
                        class: "arrow-slot",
                        "aria-hidden": "true"
                      }))
                    : (_openBlock(), _createBlock(ArrowUp, {
                        key: 2,
                        class: "arrow-slot",
                        "aria-hidden": "true"
                      }))
              ])
            ], 8, _hoisted_4)
          ]),
          _createElementVNode("th", null, [
            _createElementVNode("button", {
              class: "session-list__header__sort-button",
              type: "button",
              "aria-label": 'sort by date from ' + (sortCriteria.value === _unref(WebinarSortCriteria).Date && isSortDescending.value ? 'latest to earliest' : 'earliest to latest'),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleSort(_unref(WebinarSortCriteria).Date)))
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createTextVNode(" Date "),
                (sortCriteria.value !== _unref(WebinarSortCriteria).Date)
                  ? (_openBlock(), _createBlock(ExpandArrows, {
                      key: 0,
                      class: "arrow-slot",
                      "aria-hidden": "true"
                    }))
                  : (isSortDescending.value)
                    ? (_openBlock(), _createBlock(ArrowDown, {
                        key: 1,
                        class: "arrow-slot",
                        "aria-hidden": "true"
                      }))
                    : (_openBlock(), _createBlock(ArrowUp, {
                        key: 2,
                        class: "arrow-slot",
                        "aria-hidden": "true"
                      }))
              ])
            ], 8, _hoisted_6)
          ]),
          _createElementVNode("th", null, [
            _createElementVNode("button", {
              class: "session-list__header__sort-button",
              type: "button",
              "aria-label": 'sort by time from ' + (sortCriteria.value === _unref(WebinarSortCriteria).Time && isSortDescending.value ? 'latest to earliest' : 'earliest to latest'),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleSort(_unref(WebinarSortCriteria).Time)))
            }, [
              _createElementVNode("div", _hoisted_9, [
                _createTextVNode(" Time "),
                (sortCriteria.value !== _unref(WebinarSortCriteria).Time)
                  ? (_openBlock(), _createBlock(ExpandArrows, {
                      key: 0,
                      class: "arrow-slot",
                      "aria-hidden": "true"
                    }))
                  : (isSortDescending.value)
                    ? (_openBlock(), _createBlock(ArrowDown, {
                        key: 1,
                        class: "arrow-slot",
                        "aria-hidden": "true"
                      }))
                    : (_openBlock(), _createBlock(ArrowUp, {
                        key: 2,
                        class: "arrow-slot",
                        "aria-hidden": "true"
                      }))
              ])
            ], 8, _hoisted_8)
          ]),
          _hoisted_10,
          _hoisted_11
        ])
      ]),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(_unref(TableLoader))
          ]))
        : (_openBlock(), _createElementBlock("tbody", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedWebinars.value, (event) => {
              return (_openBlock(), _createBlock(_unref(WebinarListItem), {
                key: event.sessionId,
                "model-value": event,
                disabled: _ctx.disabled,
                "is-last-row": event == paginatedWebinars.value[paginatedWebinars.value.length-1]
              }, null, 8, ["model-value", "disabled", "is-last-row"]))
            }), 128))
          ])),
      (showMessage.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(messageValue.value), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_15, [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createVNode(_unref(TableLoader))
          ]))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(paginatedWebinars.value, (event) => {
            return (_openBlock(), _createBlock(WebinarMobileListItem, {
              key: event.sessionId,
              "model-value": event,
              disabled: _ctx.disabled,
              "is-last-row": event == paginatedWebinars.value[paginatedWebinars.value.length-1]
            }, null, 8, ["model-value", "disabled", "is-last-row"]))
          }), 128))
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(['nav-footer fs-6 flex-column flex-md-row', {'nav-footer__no-pages': totalWebinarPages.value <= 1}])
    }, [
      _createElementVNode("span", null, [
        _createTextVNode(" Showing " + _toDisplayString(firstIndex.value) + " - " + _toDisplayString(lastIndex.value) + " of " + _toDisplayString(filteredWebinars.value.length) + " • ", 1),
        _createElementVNode("button", {
          class: "expand-btn",
          onClick: webinarExpand
        }, [
          (webinarsPerPage.value != 100000)
            ? (_openBlock(), _createElementBlock("span", _hoisted_17, "View All"))
            : (_openBlock(), _createElementBlock("span", _hoisted_18, "Collapse"))
        ])
      ]),
      _withDirectives(_createVNode(_unref(PaginationBar), {
        "pagination-value": currentPage.value,
        "onUpdate:paginationValue": _cache[3] || (_cache[3] = ($event: any) => ((currentPage).value = $event)),
        "total-pages": totalWebinarPages.value,
        spread: 2,
        disabled: _ctx.disabled
      }, null, 8, ["pagination-value", "total-pages", "disabled"]), [
        [_vShow, totalWebinarPages.value > 1]
      ])
    ], 2)
  ]))
}
}

})